module.exports = __webpack_public_path__ + "static/img/cont43_07.a47f0e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_07.jpg
// module id = eYvE
// module chunks = 0